// eslint-disable-next-line
import { register } from "swiper/element/bundle";
import initHandlersCarousel from "./components/carousel";
import {
  productBlockCarousel,
  progressBlockCarousel
} from "./components/swiper-carousel";
import * as bootstrap from "./_bootstrap";
import buttons from "./components/button";
import pagination from "./components/pagination";
import { updateViewMode, updateCategoryButton } from "./components/siteConfig";

(function() {
  // * Tooltip initialization, remove it if not necessary
  document
    .querySelectorAll('[data-toggle="tooltip"]')
    .forEach(tooltipElement => new bootstrap.Tooltip(tooltipElement));

  // * Toast initialization, remove it if not necessary
  document
    .querySelectorAll(".toast")
    .forEach(toastElement => new bootstrap.Toast(toastElement));
  buttons();
  // * Initialize swiper
  register();
  updateViewMode();
  updateCategoryButton();

  // * Initialize carousel Haddlers
  initHandlersCarousel();
  productBlockCarousel();
  progressBlockCarousel();

  Drupal.bootstrap = bootstrap;

  const bodyElement = document.body;
  if (/wv|WebView/.test(navigator.userAgent)) {
    bodyElement.classList.add("webview");
    bodyElement.classList.add("webview-android");
  } else if (
    /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(navigator.userAgent)
  ) {
    bodyElement.classList.add("webview");
    bodyElement.classList.add("webview-ios");
  }
})();
